import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchSubCategoryList,
  updateSubCategoryList,
} from "../../../slices/LocationSlice/subCategorySlice";

import Pagination from "../../../components/Pagination";
import EditableTable from "./SubCategoryTable";
import Modal from "../../../components/Modal";
import ChangeLog from "../../../components/ChangeLog";
import AddSubCategory from "./AddSubCategory";
import { fetchCountryList } from "../../../slices/LocationSlice/countrySlice";
import Loader from "../../../components/Loader"



function SubCategory() {
  const dispatch = useDispatch();
  const { subCategoryList, status, error } = useSelector((state) => state.subCategory);
  const [currentPage, setCurrentPage] = useState(1);
  const [editRowId, setEditRowId] = useState(null);
  const [editedData, setEditedData] = useState({});

  const itemsPerPage = 10;
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = Array.isArray(subCategoryList?.result)
    ? subCategoryList?.result?.slice(indexOfFirstItem, indexOfLastItem)
    : [];
  const totalPages = Array.isArray(subCategoryList?.result)
    ? Math.ceil(subCategoryList?.result?.length / itemsPerPage)
    : 0;
  const headers =
  subCategoryList?.result?.length > 0
      ? Object.keys(subCategoryList.result[0]).filter((key) => key !== "id")
      : [];
  const editableFields = ["title"]; // Define editable fields

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [currentLog, setCurrentLog] = useState([]);
  const [addCountryModal, setAddCountryModal] = useState(false);

  const openModal = () => setIsModalOpen(true);
  const closeModal = () => setIsModalOpen(false);




  useEffect(() => {
    if (status === "idle") {
      dispatch(fetchSubCategoryList());
    }
  }, [dispatch]);

  // if (status === "loading") {
  //   return <Loader></Loader>;
  // }

  const handleEdit = (rowId) => {
    setEditRowId(rowId);
    const rowData = subCategoryList.result.find((user) => user.id === rowId);
    setEditedData(rowData);
  };

  const handleSave = async () => {
    const { id, title } = editedData;

    const resp = await dispatch(updateSubCategoryList({id,title}));
    if (!resp.error) {
      setEditRowId(null);
      dispatch(fetchSubCategoryList());
    }
  };

  const handleCancel = () => {
    setEditRowId(null);
    setEditedData({});
  };

  const handleChange = (e, field, val) => {
    if (["status", "active"].includes(field)) {
      setEditedData((prev) => ({
        ...prev,
        [field]: !val,
      }));
    } else {
      setEditedData((prev) => ({
        ...prev,
        [field]: e.target.value,
      }));
    }
  };

  const handleLog = (id) => {
    const logData = subCategoryList.Change_Log.filter((f) => f.id === id)[0]
      ?.oldTrack;
    setCurrentLog(logData);
    openModal();
  };

  return (
    <div className="w-full flex items-center flex-col">


      {status==='loading'?<>
        <Loader></Loader>
      </>:
      <div className="max-w-full">
<EditableTable
       headers={headers}
       rows={currentItems}
       editRowId={editRowId}
       editedData={editedData}
       handleEdit={handleEdit}
       handleSave={handleSave}
       handleCancel={handleCancel}
       handleChange={handleChange}
       handleLog={handleLog}
       editableFields={editableFields} // Pass editable fields
     />
      </div>
       
      }
     


      <div className="flex mt-4 items-center justify-between w-11/12">
      <Pagination
  currentPage={currentPage}
  setCurrentPage={setCurrentPage}
  totalPages={totalPages}
/>

        <button
          className="activeBtn text-sm text-white  py-1 px-2 rounded"
          onClick={() => setAddCountryModal(true)}
        >
          + Add Sub-Category
        </button>
      </div>

      <Modal
        isOpen={isModalOpen}
        onClose={closeModal}
        title="Change Log"
        content={<ChangeLog data={currentLog} />}
      />

      <Modal
        isOpen={addCountryModal}
        onClose={() => setAddCountryModal(false)}
        title="Add Sub-Category"
        content={
          <AddSubCategory />
        }
      />
    </div>
  );
}

export default SubCategory;
